import { render, staticRenderFns } from "./another-product.vue?vue&type=template&id=75e2cea5&"
import script from "./another-product.vue?vue&type=script&lang=tsx&"
export * from "./another-product.vue?vue&type=script&lang=tsx&"
import style0 from "./another-product.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports